import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  Typography,
} from "@mui/material";
import theme from "../../configs/theme";

export default function ProductFilter({ onFilterChange, productTypes, empresaRubro }) {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [priceMin, setPriceMin] = useState("");
  const [priceMax, setPriceMax] = useState("");

  const isServicio = empresaRubro === "Servicios";

  useEffect(() => {
    const min = priceMin === "" ? 0 : Number(priceMin);
    const max = priceMax === "" ? Number.MAX_SAFE_INTEGER : Number(priceMax);

    onFilterChange({ 
      name, 
      type, 
      priceRange: [min, max], 
    });
  }, [name, type, priceMin, priceMax, onFilterChange]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        width: "100%",
        bgcolor: theme.tableColors.header,
        px: 1,
        py: 0.8,
        borderRadius: 2,
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ display: "flex", gap: 1, flex: 1 }}>
        <TextField
          label={isServicio ? "Servicio" : "Producto"}
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ bgcolor: theme.tableColors.body }}
        />

        <FormControl fullWidth>
          <InputLabel>Tipo</InputLabel>
          <Select
            value={type}
            label="Tipo"
            onChange={(e) => setType(e.target.value)}
            sx={{ bgcolor: theme.tableColors.body }}
          >
            <MenuItem value="">Todos</MenuItem>
            {productTypes.map((type) => (
              <MenuItem key={type.id} value={type.type}>
                {type.type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          bgcolor: theme.tableColors.body,
          px: 2,
          py: 1,
          borderRadius: 1,
        }}
      >
        <Typography variant="subtitle2" sx={{ whiteSpace: "nowrap" }}>
          Precio:
        </Typography>
        <TextField
          type="number"
          label="Mín"
          size="small"
          value={priceMin}
          onChange={(e) => {
            const value = e.target.value;
            setPriceMin(value === "" ? "" : value);
          }}
          onFocus={(e) => e.target.select()}
          sx={{ width: "120px"}}
        />
        <TextField
          type="number"
          label="Máx"
          size="small"
          value={priceMax}
          onChange={(e) => {
            const value = e.target.value;
            setPriceMax(value === "" ? "" : value);
          }}
          onFocus={(e) => e.target.select()}
          sx={{ width: "120px"}}
        />
      </Box>
    </Box>
  )
}